import controller from './event-function.controller.js';

let eventFunctionModule = angular.module('event-function', [])

    .directive('eventFunction', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default eventFunctionModule;



// WEBPACK FOOTER //
// ./src/app/angular/event-function/event-function.js